/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';

import Layout from "components/Layout/index";
import StepNavigation from "components/StepNavigation";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer, ButtonContent } from 'components/Button';
import FileModal from "components/FileModal";
import BrokingSummary from "components/BrokingSummary";
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import DialogComponentCancel from 'components/ModalCancel';
import { Col, Row } from 'components/Grid';
import TagList2 from 'components/TagList2';
import Label from "components/Form/Label";

import Colors from 'constants/Colors';
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';

export default function SendEndorsementPackRiskMktChanges(props) {
	const [file, setFile] = useState([]);
	const [attachments, setAttachments] = useState([]);
	const [summary, setSummary] = useState({});
	const authContext = useContext(GlobalAuthContext);
	const formik = useRef(null);
	const history = useHistory();
	const fitinsur = new FitinsurAPI();
	const mc = new MessageCenter();
	const loading = useContext(GlobalLoaderContext);
	const [dialog, setDialog] = useState({ visible: false });

	function handleOpenModalCancel() {
		setDialog({
			visible: true,
		})
	}

	function handleSummary() {
		loading.start();
		fitinsur.setAuthToken(authContext.token);
		fitinsur.requestHeaderNbi(props.match.params.idOperation)
			.then(response => response.json()).then(data => {
				console.log("Sumario-> ", data.ret_value)
				setSummary({
					typeOfCover: data.ret_value.typeOfCover,
					client: data.ret_value.client,
					obligorCoding: data.ret_value.obligorCoding,
					responseBy: data.ret_value.responseBy,
					internalContact: data.ret_value.internalContact,
					broker: data.ret_value.broker,
					dealCode: data.ret_value.deal,
					nmFacility: data.ret_value.nmFacility,
					nmObligor: data.ret_value.nmObligor,
					projectName: data.ret_value.projectName,
				});
			})
			.catch((error) => {
				mc.error("Erro executando consulta\n" + error);
				console.error('fitPostSummary - Error:', error);
			});
		loading.stop();
	};

	function handleSendApproval() {

		// Comment
		alert('Send!');
		return;

		/* fitinsur.setAuthToken(authContext.token);
		fitinsur.endorsementOffRiskSendApproval(props.match.params.idOperation, formik.current.values.endorsementPackMessage)
			.then(resp => resp.json())
			.then(data => {
				if (data.ret_code !== 200) {
					mc.error(data.ret_msg_details);
					return;
				}
				history.push(`/broking/endorsement-off-risk-approval/${props.match.params.idOperation}`, { idProduct: props.location?.state?.idProduct || null });
			})
			.catch((error) => {
				mc.error("Erro executando consulta\n" + error);
				console.error('fitPostReject - Error:', error);
			}); */
	}

	function handleGetModal() {
		
		//Recuperando EndorsementPack document 453 
		fitinsur.setAuthToken(authContext.token);
		fitinsur.endorsementPackRiskMarketDocHtmlModal(props.match.params.idOperation)
			.then(x => x.json())
			.then(resp => {
				setFile(state => [...state , ...resp.ret_value]);
			}).catch((error) => {
				mc.error("Erro executando consulta\n" + error);
				console.error('fitPostReject - Error:', error);
			});

		//Recuperando shedulles
		fitinsur.setAuthToken(authContext.token);
		fitinsur.requestScheduleReport(props.match.params.idOperation)
			.then(response => {
				return response.json()
			})
			.then(data => {
				if (data.ret_code !== 200) {
					mc.error(data.ret_msg_details);
					//history.goBack();
					return;
				}
				setFile(state => [...state , ...data.ret_value]);
			})
			.catch((error) => {
				mc.error(`There was an error while fetching your data: ${handleGetModal.name}\n` + error);
				console.error('fitPostDocument - Error:', error);
			});
	};

	function handleGetFiles() {
		loading.start();

		// Carregando documento de wording
		fitinsur.requestGetDocuments(props.match.params.idOperation)
			.then(data => data.json())
			.then(response => {
				const files = response.ret_value;
				let aux = [];

				files.forEach(file => {
					let obj = {
						dsTypeDocument: "Attachment",
						nameDocument: file.nameDocument,
						idTypeDocument: file.idTypeDocument,
						nameFile: file.nameFile,
						size: file.size,
						type: file.type,
						urlLink: file.urlLink,
						idDocument: file.idDocument
					};
					aux.push(obj);
				});
				setAttachments(aux);
			})
			.catch((error) => {
				mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
				console.error('fitPostFiles - Error:', error);
			});

		// Carregando schedulle assumptions
		fitinsur.requestGetSchedulleAssumptions(props.match.params.idOperation)
			.then(data => data.json())
			.then(response => {
				const files = response.ret_value;
				let aux = [];

				files.forEach(file => {
					let obj = {
						dsTypeDocument: "Attachment",
						nameDocument: file.nameDocument,
						idTypeDocument: file.idTypeDocument,
						nameFile: file.nameFile,
						size: file.size,
						type: file.type,
						urlLink: file.urlLink,
						idDocument: file.idDocument
					};
					aux.push(obj);
				});
				setAttachments([...attachments, ...aux]);
			})
			.catch((error) => {
				mc.error(`There was an error while fetching your data: ${fitinsur.requestGetSchedulleAssumptions.name}\n` + error);
				console.error('fitPostFiles - Error:', error);
			});

		loading.stop();
	}

	function requestBindMessage() {
		fitinsur.setAuthToken(authContext.token);
		fitinsur.endorsementPackRiskMarketChangesFormData(props.match.params.idOperation)
			.then(x => x.json())
			.then(resp => {
				if (resp.ret_code != 200) {
					mc.error(resp.ret_msg_details);
					return;
				}

				if (formik.current) {
					formik.current?.setFieldValue('endorsementPackMessage', resp.ret_value.message);
				}
			}).catch((error) => {
				mc.error("Erro executando consulta\n" + error);
				console.error('fitPostReject - Error:', error);
			});
	};

	const goToLoginPage = () => {
		history.push('login');
	};

	useEffect(() => {
		if (authContext.status !== true) {
			mc.error("Usuário não autenticado");
			loading.stop();
			goToLoginPage();
			return;
		}
		else {
			fitinsur.setAuthToken(authContext.token);
			loading.stop();
		};
		requestBindMessage();
		handleGetModal();
		handleSummary();
		handleGetFiles();
	}, [])

	return (
		<Layout
			idOperation={props.match?.params?.idOperation}
			title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
			subtitle={summary.dealCode ? summary.dealCode : "Broking code"}>

			<StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />
			<BrokingSummary data={summary} />

			<ContentCard title={'RISK & MARKET CHANGES - ENDORSEMENT PACK APPROVAL'}
				icon
				info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}
			>
				<DialogComponentCancel history={history} show={dialog.visible} setDialog={setDialog} idOperation={props.match?.params?.idOperation} />
				<Formik
					innerRef={formik}
					initialValues={{}}
					onSubmit={() => { }}>
					{formikProps => (
						<Form>
							<Field
								label={'*Endorsement Pack - Message'}
								name={'endorsementPackMessage'}
								value={formikProps.values.endorsementPackMessage}
								onChange={(e) => formikProps?.setFieldValue('endorsementPackMessage', e)}
								component={TextField}
							/>

							<FileModal idOperation={props?.match?.params?.idOperation} file={file} />

							<Row>
								<Col md={6} style={{ marginTop: "15px" }}>
									<Label>Attachments</Label>
									<TagList2
										tags={attachments}
										disableType
										hideTrash
									/>
								</Col>
							</Row>

							<ButtonContainer>
								<Button forth onClick={() => history.goBack()}>&lt; Back</Button>
								<ButtonContent>
									<Button
										secundary
										name="CANCEL"
										id="btnLost"
										onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleOpenModalCancel() }}>
										CANCEL
									</Button>
									<Button
										primary
										style={{ marginLeft: "10px" }}
										name="SEND APPROVAL"
										id="mktComposition"
										onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleSendApproval() }}>
										SEND APPROVAL
									</Button>
								</ButtonContent>
							</ButtonContainer>
						</Form>
					)}
				</Formik>
			</ContentCard>
			{loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
		</Layout>
	);
}
